import {MP_API_PREFIX, USER_API_PREFIX, V1_API_PREFIX, V2_API_PREFIX} from "@pg-mono/rp-api-routes";

import {rpServerMpApiUrl, rpServerUserApiUrl, rpServerV1ApiUrl, rpServerV2ApiUrl} from "../read_rp_environment_variables";

export const serverApiUrls = {
    [V1_API_PREFIX]: rpServerV1ApiUrl,
    [V2_API_PREFIX]: rpServerV2ApiUrl,
    [MP_API_PREFIX]: rpServerMpApiUrl,
    [USER_API_PREFIX]: rpServerUserApiUrl
};
import {MP_API_PREFIX, USER_API_PREFIX, V1_API_PREFIX, V2_API_PREFIX} from "@pg-mono/rp-api-routes";

import {rpServerMpApiUrl, rpServerUserApiUrl, rpServerV1ApiUrl, rpServerV2ApiUrl} from "../read_rp_environment_variables";

export const serverApiUrls = {
    [V1_API_PREFIX]: rpServerV1ApiUrl,
    [V2_API_PREFIX]: rpServerV2ApiUrl,
    [MP_API_PREFIX]: rpServerMpApiUrl,
    [USER_API_PREFIX]: rpServerUserApiUrl
};
